<template>
  <div class="without">
    <span>404 NOT FOUND</span>
  </div>
</template>

<script>
export default {
  name: "Without"
}
</script>

<style lang="less">
  
</style>